@import "~@uipath/apollo-core/src/scss/base-host.scss";

:host {
  display: flex;
  font-family: $font-normal;

  .profile-menu-res {
    min-width: 260px;
    max-width: 400px;
  }

  .user-anchor {
    text-decoration: none;
  }

  .user-section,
  .product-info-section {
    font-size: $font-m-size;
    line-height: $font-m-line-height;
    padding: $pad-xxxl;
    cursor: default;
  }

  .user-section {
    >.username {
      color: var(--color-foreground-emp);
      font-weight: $font-weight-semibold;
    }

    >.email {
      color: var(--color-foreground);
    }
  }

  .upgrade-section {
    display: flex;
    flex-direction: row;
    padding: $pad-l $pad-xxxl;
    align-items: center;
    justify-content: space-between;
  }

  .current-plan {
    font-size: $font-m-size;
    font-weight: $font-weight-semibold;
  }

  .upgrade-license-button {
    font-size: $font-m-size;
  }

  .menu-header {
    display: flex;
    align-items: center;
    padding-bottom: $pad-m;
    padding-left: $pad-m;

    >.text {
      color: var(--color-foreground-emp);
      font-size: $font-m-size;
      line-height: $font-m-line-height;
      font-weight: $font-weight-semibold;
      padding-left: $pad-m;
    }
  }
}

button {
  font-size: 100%;
  font-family: inherit;
  border: 0;
  padding: 0;
  background-color: transparent;
}

.portal-avatar-button {
  &:focus {
    outline: 1px solid var(--color-primary);
  }
}
